import React from 'react'

import Color from 'helpers/Color'

const BarLabel = color => ({ x, y, fill, value, width }) => {
  if (!value) return null
  return (
    <text
      x={x + width}
      dx={- 25 * Math.sign(value)}
      y={y}
      dy={15}
      textAnchor='middle'
      fill={Color.white}
    >
      {`${Math.abs(value)}°`}
    </text>
  )
}

export default BarLabel



// WEBPACK FOOTER //
// ./src/components/UI/Chart/BarLabel.jsx